{
  "getInTouch": "Ponte en contacto",
  "contactIntro": "¿Tienes una pregunta o quieres ponerte en contacto? Llena el formulario o escríbenos directamente a <supportLink>{{email}}</supportLink>",
  "poweredBy": "Desarrollado por <holigralLink>Holigral</holigralLink>",
  "terms": "Términos",
  "privacy": "Privacidad",
  "contact": "Contacto",
  "intro": "Intro",
  "getStarted": "Empezar",
  "home": {
    "hero": {
      "sub": "Ve a tu gente con claridad.",
      "title": "Entiende cómo funciona realmente tu gente.",
      "bullets": "Fortalezas • Estilo de trabajo • Encaje • Complemento",
      "one": "Un perfil."
    },
    "pain": "Puedes medir lo que alguien sabe y lo que ha hecho, pero lo que en verdad decide si prospera, encaja y permanece siempre ha sido invisible.",
    "steps": {
      "people": {
        "title": "Empieza por la gente que ya tienes.",
        "body": "Perfila a tu equipo actual y lo verás descrito de una forma para la que nunca tuviste palabras, confirmando lo que intuías y revelando lo que no. Ganancias reales en el equipo que ya diriges."
      },
      "works": {
        "title": "Ves cómo trabaja realmente cada persona.",
        "body": "No lo que sabe, sino cómo funciona. Dónde fluye su energía con naturalidad, dónde le cuesta esfuerzo, y las condiciones y el tipo de rol en los que da lo mejor de sí."
      },
      "fits": {
        "title": "Ves cómo encaja el equipo completo.",
        "body": "Las combinaciones que se multiplican entre sí, los vacíos que nadie había trazado, y la fricción que nunca fue un choque de personalidades, sino un desajuste que nadie supo nombrar. Organiza el conjunto en torno a cómo funciona realmente cada parte."
      },
      "decisions": {
        "title": "Y entonces, las decisiones que no puedes equivocar.",
        "body": "Cada contratación es un compromiso largo que se decide con un CV y una entrevista, las dos cosas que ignoran precisamente cómo encajará, trabajará y permanecerá una persona. Sea cual sea el puesto, sea cual sea el salario, toma esa decisión con los ojos abiertos."
      }
    },
    "closing": {
      "title": "Debajo de todo esto hay un método de verdad.",
      "body": "La mayoría de las formas de evaluar a las personas se quedan con lo fácil de medir y pasan por alto lo que más importa: no lo que alguien sabe, sino cómo su naturaleza se encuentra con el trabajo que tiene delante. Pam Saunders dedicó décadas a comprender cómo funcionan realmente las personas, por qué una prospera donde otra se desgasta en silencio, por qué algunas combinaciones se multiplican y otras chocan. El resultado es el método Holigral sobre el que esto funciona, una forma de ver a las personas con la claridad suficiente para situarlas donde van a prosperar.",
      "attribution": "Pam Saunders, inventora del Método Holigral"
    },
    "cta": {
      "text": "Crea un espacio de trabajo y explora perfiles de muestra. Sin tarjeta, sin llamadas, sin compromiso.",
      "button": "Empezar"
    }
  }
}
